import styles from './style.module.css';

// The one button of the design system. Primary by default: the sunflower
// accent with the hard shadow, kept for the main action of a view. secondary
// is the outlined white variant for everything beside it.
export function Button({ secondary, type = 'button', disabled, onClick, children }) {
  let className = `${ styles.button } ${ styles.primary }`;

  if (secondary === true) {
    className = `${ styles.button } ${ styles.secondary }`;
  }

  return <button className={ className } type={ type } disabled={ disabled } onClick={ onClick }>{ children }</button>;
}
